"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconQuestionWidgetBase = void 0;
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var Types_1 = require("../Types");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var FalconQuestionWidgetBase = /** @class */ (function (_super) {
    __extends(FalconQuestionWidgetBase, _super);
    function FalconQuestionWidgetBase(props) {
        var _this = _super.call(this, props) || this;
        _this.executeAndRecordNativeEvent = _this.executeAndRecordNativeEvent.bind(_this);
        return _this;
    }
    FalconQuestionWidgetBase.prototype.executeAndRecordNativeEvent = function (event) {
        var type = event.type;
        this.executeNativeEvent(event);
        this.changelogRecorder.recordQuestion(type, this.props);
    };
    FalconQuestionWidgetBase.prototype.isMtaAndDisabled = function () {
        var _a;
        if (((_a = this.props.interaction) === null || _a === void 0 ? void 0 : _a.process) === services_1.INTERACTION_PROCESS_MTA) {
            return (this.getSetting(services_1.INPUT_DISABLED_SETTING, false) || this.isReadOnly());
        }
        else {
            return false;
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], FalconQuestionWidgetBase.prototype, "changelogRecorder", void 0);
    return FalconQuestionWidgetBase;
}(plugin_journey_1.QuestionWidgetBase));
exports.FalconQuestionWidgetBase = FalconQuestionWidgetBase;
//# sourceMappingURL=FalconQuestionWidgetBase.js.map